export enum SubmissionMethod {
    API = 'API',
    Portal = 'Portal',
    Email = 'Email',
}
